import React from 'react';
import { useTranslation } from 'next-i18next';
import { useCountryCode } from '@/shared/hooks';
import { cn } from '@/utils/tailwind.util';
import { AnswerRevealModeField, ToggleAiTranslationField, ToggleAllowField, ToggleNextQuizsetField, TogglePublicField } from '@/views/build/form';
import { AiTutorSetting } from '../setting/AiTutorSetting';
import { LearningMaterialSetting } from '../setting/LearningMaterialSetting';
import { MapAndCategoryInfoSection } from './SectionBasicInfo/MapAndCategoryInfoSection';
import { BuildProFeatureCoachmarkProvider } from './BuildProFeatureCoachmark';
const SettingSection = ({
  title,
  children,
  className
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('bg-default p-xl rounded-md border border-assistive', className)} data-sentry-component="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
      <h3 className="mb-lg text-body-md-bold text-assistive">{title}</h3>
      <div className="flex flex-col gap-lg">{children}</div>
    </div>;
};
export const BuildStepSettings = () => {
  const {
    isKR
  } = useCountryCode();
  const {
    t
  } = useTranslation(['build']);
  return <BuildProFeatureCoachmarkProvider data-sentry-element="BuildProFeatureCoachmarkProvider" data-sentry-component="BuildStepSettings" data-sentry-source-file="BuildStepSettings.tsx">
      <div className="mx-auto flex max-w-[650px] flex-col gap-lg px-md mobile-lg:px-lg tablet-lg:px-0">
        <div className="flex flex-col gap-xs">
          <SettingSection title={t('build:settings.basicInfo')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
            <MapAndCategoryInfoSection data-sentry-element="MapAndCategoryInfoSection" data-sentry-source-file="BuildStepSettings.tsx" />
          </SettingSection>

          <SettingSection title={t('build:settings.quizSetting')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
            <ToggleAllowField data-sentry-element="ToggleAllowField" data-sentry-source-file="BuildStepSettings.tsx" />
            <AnswerRevealModeField data-sentry-element="AnswerRevealModeField" data-sentry-source-file="BuildStepSettings.tsx" />
          </SettingSection>

          <SettingSection title={t('build:settings.learningTool')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
            {isKR && <AiTutorSetting />}
            <ToggleAiTranslationField data-sentry-element="ToggleAiTranslationField" data-sentry-source-file="BuildStepSettings.tsx" />
            <LearningMaterialSetting data-sentry-element="LearningMaterialSetting" data-sentry-source-file="BuildStepSettings.tsx" />
          </SettingSection>

          <SettingSection title={t('build:settings.advanced')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
            <ToggleNextQuizsetField data-sentry-element="ToggleNextQuizsetField" data-sentry-source-file="BuildStepSettings.tsx" />
            <TogglePublicField data-sentry-element="TogglePublicField" data-sentry-source-file="BuildStepSettings.tsx" />
          </SettingSection>
        </div>
      </div>
    </BuildProFeatureCoachmarkProvider>;
};